module.exports = __webpack_public_path__ + "static/media/banner-aviso-mfa.5c8b6ba2.png";